import React, { useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import BrandLogo from './ui/BrandLogo';

const AuthMFA = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerify = () => {
    setError('');
    setLoading(true);
    (async () => {
      try {
        const factors = await supabase.auth.mfa.listFactors();
        if (factors.error) throw factors.error;

        const totpFactor = factors.data?.totp?.[0];
        if (!totpFactor) throw new Error('No se encontró factor TOTP.');

        const challenge = await supabase.auth.mfa.challenge({ factorId: totpFactor.id });
        if (challenge.error) throw challenge.error;

        const verify = await supabase.auth.mfa.verify({
          factorId: totpFactor.id,
          challengeId: challenge.data.id,
          code,
        });
        if (verify.error) throw verify.error;

        // Verify exitoso — Supabase refresca sesión automáticamente
        // MFAWrapper detecta el nuevo AAL y muestra la app sin navigate
      } catch (err) {
        setError(err.message || 'Código incorrecto. Intenta nuevamente.');
        setLoading(false);
      }
    })();
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-card border border-border rounded-lg shadow-elevation-2 p-6">
          <div className="text-center mb-6">
            <BrandLogo size="lg" className="mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-foreground mb-2">Verificación en dos pasos</h1>
            <p className="text-sm text-muted-foreground">Ingresa el código de 6 dígitos de tu app autenticadora.</p>
          </div>
          {error && (
            <div className="flex items-center gap-2 p-3 mb-4 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
              <span>{error}</span>
            </div>
          )}
          <input
            type="text"
            inputMode="numeric"
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/[^0-9]/g, '').slice(0, 6))}
            placeholder="000000"
            maxLength={6}
            autoFocus
            className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-1 focus:ring-primary mb-4 text-center tracking-widest text-lg"
            onKeyDown={(e) => e.key === 'Enter' && !loading && code.length === 6 && handleVerify()}
          />
          <button
            onClick={handleVerify}
            disabled={code.length !== 6 || loading}
            className="w-full py-2 px-4 bg-primary text-white rounded-lg font-medium text-sm hover:bg-primary/90 transition-colors disabled:opacity-50"
          >
            {loading ? 'Verificando...' : 'Verificar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthMFA;
